<template>
  <div v-if="loaded">
    <section-component :form="form" :gridId="gridId" :rowData="rowData"></section-component>
  </div>
</template>

<script>
import { FormHandler } from './handler/form_handler'
import SectionComponent from './ui/SectionComponent'
import { dom } from '@fortawesome/fontawesome-svg-core'

dom.watch()
export default {
  name: 'FormBuilderGui',
  components: { SectionComponent },
  props: {
    form: {
      type: Object,
    },
    gridId: {
      type: String,
    },
    rowData: {
      type: Object,
    },
  },
  data() {
    return {
      loaded: true,
    }
  },
  methods: {
    getValue() {
      return FormHandler.getValue(this.form)
    },
    setValue(values) {
      this.loaded = false
      if (!_.isObject(values)) {
        console.error('Invalid values for Form GUI!')
        return
      }

      FormHandler.setValue(this.form, values)
      this.$nextTick(() => {
        this.loaded = true
      })
    },
  },
  created() {
    // this.form = JSON.parse(localStorage.getItem('BUILD_FORM'));
  },
}
</script>

<style scoped>
</style>
